// extracted by mini-css-extract-plugin
export default {"badge":"MassListCell-module--badge--wJwCE"};